import clsx from 'clsx'

export const SkeletonGroup = ({ children }) => {
  return (
    <div className="max-w-full animate-pulse">
      {children}
    </div>
  )
}

export const Skeleton = ({ children, className }) => {
  return (
    <div className={clsx('bg-gray-300 rounded-full', className)}>
      {children}
    </div>
  )
}